<template>
  <div>
{{year}}

    <div class="accordion" role="tablist">
      <b-card no-body class="mb-1">
        <b-card-header header-tag="header" class="p-1" role="tab">
          <b-button block v-b-toggle.accordion-1 variant="info" style="text-align: left;">輪播圖</b-button>
        </b-card-header>
        <b-collapse id="accordion-1" accordion="my-accordion" role="tabpanel">
          <b-card-body>
            <ListEditImage :mode="1" :datas="datas[QueryType_Index_1_BannerImage]" image-memo="(建議圖片大小:1024x576)">
                <a role="button" class="btn btn-primary" @click="submit(QueryType_Index_1_BannerImage)"><i class="fas fa-save"></i></a>
            </ListEditImage>
          </b-card-body>
        </b-collapse>
      </b-card>

      <b-card no-body class="mb-1">
        <b-card-header header-tag="header" class="p-1" role="tab">
          <b-button block v-b-toggle.accordion-2 variant="info" style="text-align: left;">本年度營運團隊</b-button>
        </b-card-header>
        <b-collapse id="accordion-2" accordion="my-accordion" role="tabpanel">
          <b-card-body>
            <ListEditImage :mode="1" :datas="datas[QueryType_Index_2_Team]" image-memo="(建議圖片大小:400x400)">
              <a role="button" class="btn btn-primary" @click="submit(QueryType_Index_2_Team)"><i class="fas fa-save"></i></a>
            </ListEditImage>
          </b-card-body>
        </b-collapse>
      </b-card>


<!--      <b-card no-body class="mb-1">-->
<!--        <b-card-header header-tag="header" class="p-1" role="tab">-->
<!--          <b-button block v-b-toggle.accordion-5 variant="info" style="text-align: left;">3482 地區活動預告</b-button>-->
<!--        </b-card-header>-->
<!--        <b-collapse id="accordion-5" accordion="my-accordion" role="tabpanel">-->
<!--          <b-card-body>-->
<!--            <ListEditText :datas="datas[QueryType_Index_5_3482]" :show-field-memo="true">-->
<!--              <span slot="topToolbar">-->
<!--                <a role="button" class="btn btn-primary" @click="submit(QueryType_Index_5_3482)"><i class="fas fa-save"></i></a>-->
<!--              </span>-->
<!--              <span slot="rowToolbar">-->
<!--&lt;!&ndash;                <a role="button" class="btn btn-primary" @click="editDetail(QueryType_Index_5_3482)"><i class="fas fa-pen"></i></a>&ndash;&gt;-->
<!--              </span>-->
<!--            </ListEditText>-->
<!--          </b-card-body>-->
<!--        </b-collapse>-->
<!--      </b-card>-->

      <b-card no-body class="mb-1">
        <b-card-header header-tag="header" class="p-1" role="tab">
          <b-button block v-b-toggle.accordion-7 variant="info" style="text-align: left;">本年度扶輪服務影片集錦</b-button>
        </b-card-header>
        <b-collapse id="accordion-7" accordion="my-accordion" role="tabpanel">
          <b-card-body>
            <ListEditVideo :datas="datas[QueryType_Index_7_Videos]">
              <a role="button" class="btn btn-primary" @click="submit(QueryType_Index_7_Videos)"><i class="fas fa-save"></i></a>
            </ListEditVideo>
          </b-card-body>
        </b-collapse>
      </b-card>

      <b-card no-body class="mb-1">
        <b-card-header header-tag="header" class="p-1" role="tab">
          <b-button block v-b-toggle.accordion-6 variant="info" style="text-align: left;">本年度扶輪服務相片集錦</b-button>
        </b-card-header>
        <b-collapse id="accordion-6" accordion="my-accordion" role="tabpanel">
          <b-card-body>
            <ListEditImage :mode="3" :datas="datas[QueryType_Index_6_Images]" image-memo="(建議圖片大小:600x400)">
              <a role="button" class="btn btn-primary" @click="submit(QueryType_Index_6_Images)"><i class="fas fa-save"></i></a>
            </ListEditImage>
          </b-card-body>
        </b-collapse>
      </b-card>



      <b-card no-body class="mb-1">
        <b-card-header header-tag="header" class="p-1" role="tab">
          <b-button block v-b-toggle.accordion-3 variant="info" style="text-align: left;">本年度營運資料</b-button>
        </b-card-header>
        <b-collapse id="accordion-3" accordion="my-accordion" role="tabpanel">
          <b-card-body>
            <ListEditText :datas="datas[QueryType_Index_3_Op]" :show-field-memo="true">
              <span slot="topToolbar">
                <a role="button" class="btn btn-primary" @click="submit(QueryType_Index_3_Op)"><i class="fas fa-save"></i></a>
              </span>
              <span slot="rowToolbar">
<!--                <a role="button" class="btn btn-primary" @click="editDetail(QueryType_Index_3_Op)"><i class="fas fa-pen"></i></a>-->
              </span>
            </ListEditText>
          </b-card-body>
        </b-collapse>
      </b-card>

      <b-card no-body class="mb-1">
        <b-card-header header-tag="header" class="p-1" role="tab">
          <b-button block v-b-toggle.accordion-4 variant="info" style="text-align: left;">本年度活動預告</b-button>
        </b-card-header>
        <b-collapse id="accordion-4" accordion="my-accordion" role="tabpanel">
          <b-card-body>
            <ListEditText :datas="datas[QueryType_Index_4_Action]" :show-field-memo="true">
              <span slot="topToolbar">
                <a role="button" class="btn btn-primary" @click="submit(QueryType_Index_4_Action)"><i class="fas fa-save"></i></a>
              </span>
              <span slot="rowToolbar">
<!--                <a role="button" class="btn btn-primary" @click="editDetail(QueryType_Index_4_Action)"><i class="fas fa-pen"></i></a>-->
              </span>
            </ListEditText>
          </b-card-body>
        </b-collapse>
      </b-card>

    </div>

  </div>
</template>

<script>
import ListEditImage from "./component/ListEditImage";
import ListEditVideo from "./component/ListEditVideo";
import ListEditText from "./component/ListEditText";
import {
  QueryType_Index_1_BannerImage,
  QueryType_Index_2_Team,
  QueryType_Index_3_Op,
  QueryType_Index_4_Action, QueryType_Index_5_3482, QueryType_Index_6_Images, QueryType_Index_7_Videos, QueryType_Menu
} from "./js/rotaryDeclare";
import apiAdmin from "@/views/taylorAdmin/js/apiAdmin";

export default {
  components: { ListEditText, ListEditVideo, ListEditImage},
  //name: "contentEdit",
  data: function () {
    return {
      id: "",
      dataReady: false,
      formData: {
        name: "",
      },
      datas:{
        [QueryType_Index_1_BannerImage]: [],
        [QueryType_Index_2_Team]: [],
        [QueryType_Index_3_Op]: [],
        [QueryType_Index_4_Action]: [],
        [QueryType_Index_5_3482]: [],
        [QueryType_Index_6_Images]: [],
        [QueryType_Index_7_Videos]: [],
      },
      QueryType_Index_1_BannerImage:QueryType_Index_1_BannerImage,
      QueryType_Index_2_Team:QueryType_Index_2_Team,
      QueryType_Index_3_Op:QueryType_Index_3_Op,
      QueryType_Index_4_Action:QueryType_Index_4_Action,
      QueryType_Index_5_3482:QueryType_Index_5_3482,
      QueryType_Index_6_Images:QueryType_Index_6_Images,
      QueryType_Index_7_Videos:QueryType_Index_7_Videos,

      QueryType_Menu:QueryType_Menu,
      year:"",
    };
  },
  methods: {
    loadData(year) {
      this.year=year;
      // let data=await apiUtil.api_SupplierTODO("12138114-01")

      // this.data=data
      this.loadDataByQueryType(this.QueryType_Index_1_BannerImage)
      this.loadDataByQueryType(this.QueryType_Index_2_Team)
      this.loadDataByQueryType(this.QueryType_Index_3_Op)
      this.loadDataByQueryType(this.QueryType_Index_4_Action)
      this.loadDataByQueryType(this.QueryType_Index_5_3482)
      this.loadDataByQueryType(this.QueryType_Index_6_Images)
      this.loadDataByQueryType(this.QueryType_Index_7_Videos)

      // debugger // eslint-disable-line
    },
    loadDataByQueryType(queryType) {
      let yearString="";

      if (this.year){
        yearString="_" + this.year;
      }

      // let data=apiAdmin.api_getContent(this.queryType);
      // debugger // eslint-disable-line
      // console.log(data);
      let that=this;
      apiAdmin.api_getContent(queryType + yearString).then((data)=>{
        let dataArray=apiAdmin.init(data.data.data);
        // debugger // eslint-disable-line
        // that.datas[queryType]=dataArray;
        that.$set(that.datas,queryType,dataArray)
        console.log(queryType);
        console.log("set " + dataArray);
        console.info(that.datas);
      })
    },
    submit(queryType){
      // for (let i = 0; i < this.datas.Details.length; i++) {
      //   let item = this.datas.Details[i];
      //
      //   if (item.Year===""){
      //     util.showErrorMessage("第"+i+1+" 行，「年」為必填欄位")
      //     return;
      //   }
      // }

      let yearString="";

      if (this.year){
        yearString="_" + this.year;
      }

      apiAdmin.api_saveContent(queryType + yearString,this.datas[queryType]).then((data)=>{
        console.log(data);
        alert('儲存成功')
      })
    },
    editDetail(type){ // eslint-disable-line
      alert('測試中，尚未開放')
    }
  },
  mounted() {
    // this.loadData("")  不要自動載，以免封存畫面，一開始會載入本年度
  },
}
</script>


<style scoped>
/*.btn{*/
/*  color: white !important;*/
/*  width: 200px;*/
/*  height: 80px;*/
/*  margin: 10px;*/
/*}*/
</style>
